import { NO_SHOW_TIMEMARK_IN_MINS } from '../constants/app-constants';
import { Booking, SessionStatus } from '../core/models/booking';
import { calculateTimeDifference, convertToDate, getCurrentTime, minutesToMilliseconds } from './time-util';

const VIDEO_MEETING_NOT_STARTED_YET_STATUSES: SessionStatus[] = ['NOT_STARTED', 'STARTED', 'HEALLO_COMPLETED'];
const FINAL_SESSION_STATUSES: SessionStatus[] = ['CLIENT_NO_SHOW', 'FINISHED', 'CANCELLED_BY_HEALER', 'CANCELLED_BY_CLIENT'];
const VALID_FOR_RESCHEDULE_STATUSES: SessionStatus[] = ['NOT_STARTED', 'CANCELLED_BY_HEALER'];
const VALID_FOR_CANCELLING_STATUSES: SessionStatus[] = ['NOT_STARTED'];

export function videoMeetingNotStartedYet(sessionStatus?: SessionStatus) {
  return sessionStatus !== undefined && VIDEO_MEETING_NOT_STARTED_YET_STATUSES.includes(sessionStatus);
}

export function meetingInProgress(sessionStatus?: SessionStatus) {
  return sessionStatus === 'MEETING_IN_PROGRESS';
}

export function isSessionNotStarted(sessionStatus?: SessionStatus) {
  return sessionStatus === 'NOT_STARTED';
}

export function isSessionStarted(sessionStatus?: SessionStatus) {
  return sessionStatus === 'STARTED';
}

export function isHealloCompleted(sessionStatus?: SessionStatus) {
  return sessionStatus === 'HEALLO_COMPLETED';
}

export function isSessionInFinalStatus(sessionStatus?: SessionStatus): boolean {
  return sessionStatus !== undefined && FINAL_SESSION_STATUSES.includes(sessionStatus);
}

export function canRescheduleAsClient(booking?: Booking): boolean {
  if (booking == null) {
    return false;
  }
  return VALID_FOR_RESCHEDULE_STATUSES.includes(booking.sessionStatus);
}

export function canCancelBookingAsHealer(booking?: Booking): boolean {
  if (booking == null) {
    return false;
  }
  return VALID_FOR_CANCELLING_STATUSES.includes(booking.sessionStatus);
}

export const isClientNoShow = (bookedTime: string | Date | undefined, sessionStatus: SessionStatus | undefined) => {
  return (isPastNoShowDeadline(bookedTime) && videoMeetingNotStartedYet(sessionStatus)) || sessionStatus === 'CLIENT_NO_SHOW';
};

export const isPastNoShowDeadline = (bookedTime: string | Date | undefined) => {
  if (!bookedTime) return false;
  const now = getCurrentTime();
  bookedTime = convertToDate(bookedTime);

  const diff = calculateTimeDifference(now, bookedTime);
  return diff > 0 && diff >= minutesToMilliseconds(NO_SHOW_TIMEMARK_IN_MINS);
};

export function getClientFullName(booking?: Booking) {
  return booking?.client?.firstName ? booking?.client?.firstName + ' ' + booking?.client?.lastName : undefined;
}

export function getClientFirstName(booking?: Booking) {
  return booking?.client?.firstName ? booking?.client?.firstName : undefined;
}

export function getHealerFirstName(booking?: Booking) {
  return booking?.healer?.firstName ? booking?.healer?.firstName : undefined;
}

export function getClientInitials(booking?: Booking) {
  return booking?.client?.firstName && booking?.client?.lastName ? booking?.client?.firstName[0] + booking?.client?.lastName[0] : undefined;
}

export function getHealerFullName(booking?: Booking) {
  return booking?.healer?.firstName ? booking?.healer?.firstName + ' ' + booking?.healer?.lastName : undefined;
}

export function getHealerInitials(booking?: Booking) {
  return booking?.healer?.firstName && booking?.healer?.lastName ? booking?.healer?.firstName[0] + booking?.healer?.lastName[0] : undefined;
}

export function getHealerAvatar(booking?: Booking) {
  return booking?.healer?.avatar != null ? booking?.healer.avatar : undefined;
}

export function getClientAvatar(booking?: Booking) {
  return booking?.client?.avatar != null ? booking?.client.avatar : undefined;
}
